/** Canonical application permission section keys */
export const APPLICATION_SECTIONS = [
  'dashboard',
  'taskflow',
  'analytics_dashboard',
  'leads',
  'lead_assignee_change',
  'lead_follow_ups',
  'lead_conversion',
  'customers',
  'customer_documents',
  'sales_quotations',
  'sales_orders_doc',
  'sales_orders_sale',
  'sales_orders_rental',
  'sales_orders_replacement',
  'replacement_so_laptop_qc',
  'so_laptop_qc',
  'sales_order_cancel',
  'delivery_challans',
  'bluedart_awb_tracking',
  'return_dc',
  'delivery_register_management',
  'delivery_register_otp',
  'technician_bucket',
  'delivery_technicians',
  'delivery_my_deliveries',
  'support_technician',
  'technicians_bucket_list',
  'payment_records',
  'vendor_management',
  'vendor_repair_dc',
  'vendor_repair_dc_dispatch',
  'procurement',
  'sales_pipeline',
  'floor_pipeline',
  'floor_tickets',
  'floor_ticket_config_edit',
  'chip_level_repair',
  'qc_management',
  'dispatch_qc',
  'pending_inventory',
  'diagnosis_failed',
  'tickets',
  'inventory',
  'inventory_management',
  'inventory_master_data',
  'inventory_vendor_master_data',
  'inventory_return_master_data',
  'inventory_asset_movement',
  'asset_config_edit',
  'stock_send_to_floor',
  'stock_ready_send',
  'picker_tasks',
  'floor_roster',
  'diagnosis_failed_decide',
  'qc_add_laptop',
  'qc_move_to_ticket',
  'qc_create_production_ticket',
  'ready_to_rent_location',
  'dispatch_charger',
  'dispatch_charger_reset',
  'dispatch_charger_warehouse',
  'parts',
  'parts_dashboard',
  'parts_inventory',
  'parts_approval',
  'part_request_cancel',
  'parts_history',
  'parts_procurement',
  'part_vendor_repair',
  'parts_discarded',
  'physical_dead_parts',
  'scrap_challans',
  'scrap_approval',
  'parts_detach',
  'parts_requests',
  'support_part_challan',
  'support_part_requests',
  'customer_inventory',
  'customer_assets',
  'ttspl_history',
  'warehouse',
  'dispatch',
  'dispatch_ops',
  'dispatch_workflow',
  'dispatch_pending_orders',
  'customer_billing',
  'vendor_billing_mgmt',
  'credit_notes',
  'debit_notes',
  'security_deposits',
  'billing_dashboard',
  'einvoice_ewb',
  'dc_eway_bill',
  'sale_in_place',
  'support_tickets',
  'support_closed_tickets',
  'support_requests',
  'support_settings',
  'loan_laptops',
  'loan_laptop_approval',
  'loan_laptop_policy',
  'technician_performance',
  'qc_performance',
  'my_performance',
  'grn_pending_serial',
  'procure_receiving',
  'procure_amounts',
  'procure_po_bills',
  'po_approval',
  'vendor_rentals',
  'training_progress',
  'reports',
  'reports_access',
  'reports_export',
  'report_revenue',
  'report_inventory',
  'report_lead_conversion',
  'report_salesperson',
  'report_collections',
  'report_vendor_spend',
  'report_laptop',
  'report_warehouse_laptops',
  'report_sales_order',
  'report_support_daily',
  'report_inward_outward',
  'report_snapshot',
  'report_inward_outward_dashboard',
  'production_qc_report',
  'manager_dashboard',
  'users',
  'teams',
  'roles',
  'role_permissions',
  'user_permissions',
  'company_settings',
  'asset_configuration',
  'guard_gate_checking',
  'gate_dashboard',
  'whatsapp_campaigns',
  'whatsapp_campaigns_start',
  'whatsapp_campaigns_pause',
  'whatsapp_campaigns_cancel',
];

export const SECTION_LABELS = {
  dashboard: 'Dashboard',
  taskflow: 'TaskFlow',
  analytics_dashboard: 'Analytics Dashboards (Manager & Sales)',
  leads: 'Leads',
  lead_assignee_change: 'Lead Assignee (View = filter, Edit = change)',
  lead_follow_ups: 'Follow-ups',
  lead_conversion: 'Lead Conversion',
  customers: 'Customers',
  customer_documents: 'Customer Documents',
  sales_quotations: 'Quotations',
  sales_orders_doc: 'Sales Orders (legacy)',
  sales_orders_sale: 'Sales Order – Sale',
  sales_orders_rental: 'Sales Order – Rental',
  sales_orders_replacement: 'Sales Orders – Replacement',
  replacement_so_laptop_qc: 'Replacement SO — Laptop & QC',
  so_laptop_qc: 'Sales SO — Laptops & QC (Rental/Sale)',
  sales_order_cancel: 'Sales Order — Partial cancel (Rental/Sale)',
  delivery_challans: 'Delivery Challans',
  bluedart_awb_tracking: 'BlueDart AWB Tracking',
  return_dc: 'Return DC',
  delivery_register_management: 'Delivery Register',
  delivery_register_otp: 'Delivery Register — View OTP',
  technician_bucket: 'Delivery Technician',
  delivery_technicians: 'Delivery Technicians',
  delivery_my_deliveries: 'My Deliveries',
  support_technician: 'Support Technician (Field)',
  technicians_bucket_list: 'Technicians Bucket (Admin)',
  payment_records: 'Payment Records',
  vendor_management: 'Vendor Management',
  vendor_repair_dc: 'Vendor Repair DC (Laptops)',
  vendor_repair_dc_dispatch: 'Vendor Repair DC — Sign, Dispatch & Delivery',
  procurement: 'Procurement',
  sales_pipeline: 'Sales Pipeline',
  floor_pipeline: 'Floor Pipeline',
  floor_tickets: 'Floor Tickets',
  floor_ticket_config_edit: 'Floor Tickets — Edit Config',
  chip_level_repair: 'Chip Level Repair',
  qc_management: 'QC Management',
  dispatch_qc: 'Dispatch QC',
  pending_inventory: 'QC Ready',
  diagnosis_failed: 'Diagnosis Failed — Out for Repair',
  tickets: 'Tickets (Legacy)',
  inventory: 'Inventory',
  inventory_management: 'Inventory Management',
  inventory_master_data: 'Master Data Dashboard',
  inventory_vendor_master_data: 'Master Vendor Data',
  inventory_return_master_data: 'Master Return Data',
  inventory_asset_movement: 'Inventory — Asset Movement',
  qc_add_laptop: 'QC Process — add new laptop',
  qc_move_to_ticket: 'QC Pending / Dead — move to QC Process + ticket',
  qc_create_production_ticket: 'QC Process — Create Production Ticket',
  ready_to_rent_location: 'Ready to Rent/Sell — change location',
  dispatch_charger: 'Dispatch QC — attach charger',
  dispatch_charger_reset: 'Dispatch QC — cancel "charger already with customer"',
  dispatch_charger_warehouse: 'Warehouse — dispatch charger handover',
  parts: 'Parts (Legacy)',
  parts_dashboard: 'Parts Dashboard',
  parts_inventory: 'Parts Inventory',
  parts_approval: 'Parts Approval',
  part_request_cancel: 'Parts — Cancel a part request before the warehouse gives a unit (floor & field technicians)',
  parts_approval_export: 'Parts Approval — Export CSV',
  parts_history: 'Parts Movement History',
  parts_procurement: 'Spare Parts PO',
  part_vendor_repair: 'Part Vendor Repair DC',
  parts_discarded: 'Discarded Parts',
  physical_dead_parts: 'Dead / Physical Parts',
  scrap_challans: 'Scrap Challans',
  scrap_approval: 'Approve Laptop Scrap',
  parts_detach: 'Part Detach (Attached → Inventory)',
  parts_requests: 'Part Requests (Floor)',
  support_part_challan: 'Support Part Queue',
  support_part_requests: 'Technician Parts Bucket',
  customer_inventory: 'Customer Inventory',
  // Enforced by the backend (customer laptops / edit asset / exports) but was missing here,
  // so the Roles & Permissions screen could not manage it.
  customer_assets: 'Customer Assets (edit rate / export)',
  dispatch_workflow: 'Dispatch Workflow',
  dispatch_pending_orders: 'Dispatch Pending Orders',
  ttspl_history: 'TTSPL History',
  warehouse: 'Warehouse',
  dispatch: 'Dispatch',
  dispatch_ops: 'Dispatch Operations',
  customer_billing: 'Customer Billing',
  vendor_billing_mgmt: 'Vendor Billing',
  credit_notes: 'Credit Notes',
  debit_notes: 'Debit Notes',
  security_deposits: 'Security Deposits',
  billing_dashboard: 'Billing Dashboard',
  einvoice_ewb: 'E-Invoice & E-Way Bill',
  dc_eway_bill: 'DC E-Way Bill Management',
  sale_in_place: 'Lost / Buyout Sale (stop rent + sale order)',
  support_tickets: 'Support Tickets',
  support_closed_tickets: 'Support — Closed tickets (open every old ticket, read-only)',
  support_requests: 'Support Requests (QR)',
  support_settings: 'Support Settings',
  loan_laptops: 'Loan Laptops (request / track / customer decision)',
  loan_laptop_approval: 'Loan Laptop Approval (Accounts — price & conversion)',
  loan_laptop_policy: 'Loan Laptop Replacement Policy',
  technician_performance: 'Technician Performance (jobs, QC result, incentive vs target)',
  qc_performance: 'QC Performance (QC1/QC2/Dispatch QC checks, missed, incentive vs target)',
  my_performance: 'My Performance (own jobs / QC checks, incentive vs target)',
  grn_pending_serial: 'GRN without serial (receive a Not On laptop with TTSPL only; add its serial later)',
  procure_receiving: 'Procurement — Receive goods (GRN, receive laptops & spare parts, close arrivals)',
  procure_amounts: 'Procurement — See amounts (prices, rates, totals, values)',
  procure_po_bills: 'Procurement — PO PDF and vendor bills (download PO / spare PO PDF; upload and open bills)',
  po_approval: 'Purchase orders — Approve or send back (laptop and spare-parts POs)',
  asset_config_edit: 'Asset configuration — Edit (brand, model, processor, generation, RAM, storage)',
  stock_send_to_floor: 'Stock — Send to floor (laptops in stock with no floor ticket)',
  stock_ready_send: 'Ready stock — Send a laptop to Floor, QC1 or QC2',
  picker_tasks: 'Picker — laptops to carry (scan TTSPL, hand over)',
  floor_roster: 'Floor roster — who works which stage, who is absent',
  diagnosis_failed_decide: 'Vendor returns — Diagnosis failed: decide repair or send back',
  vendor_rentals: 'Vendor Rentals (laptops rented from vendors)',
  training_progress: 'Training progress (who finished Learn the flow, quiz scores)',
  reports: 'Reports (legacy)',
  reports_access: 'Reports Access (legacy)',
  reports_export: 'Export Reports',
  report_revenue: 'Report — Revenue',
  report_inventory: 'Report — Inventory Utilisation',
  report_lead_conversion: 'Report — Lead Conversion',
  report_salesperson: 'Report — Salesperson',
  report_collections: 'Report — Collections',
  report_vendor_spend: 'Report — Vendor Spend',
  report_laptop: 'Report — Technician / Laptop',
  report_warehouse_laptops: 'Report — Warehouse Laptops',
  report_sales_order: 'Report — Sales Order',
  report_support_daily: 'Report — Daily Support Summary',
  report_inward_outward: 'Report — Inward & Outward Summary',
  report_snapshot: 'Report — Snapshot dashboard',
  report_inward_outward_dashboard: 'Report — Inward & Outward dashboard (with amounts)',
  production_qc_report: 'Report — Production QC',
  manager_dashboard: 'Manager Dashboard (legacy)',
  users: 'User Management',
  teams: 'Team Management',
  roles: 'Role Management',
  role_permissions: 'Role Permissions',
  user_permissions: 'User Permissions',
  company_settings: 'Company Settings',
  asset_configuration: 'Asset Configuration',
  guard_gate_checking: 'Guard Scanner',
  gate_dashboard: 'Gate Dashboard',
  whatsapp_campaigns: 'WhatsApp Campaigns',
  whatsapp_campaigns_start: 'WhatsApp Campaigns — start / resume (Edit)',
  whatsapp_campaigns_pause: 'WhatsApp Campaigns — pause (Edit)',
  whatsapp_campaigns_cancel: 'WhatsApp Campaigns — cancel (Edit)',
};

export const SECTION_GROUPS = {
  Core: ['dashboard', 'taskflow'],
  'Lead & Sales CRM': [
    'leads', 'lead_assignee_change', 'lead_follow_ups', 'lead_conversion', 'customers', 'customer_documents',
    'sales_quotations', 'sales_orders_sale', 'sales_orders_rental', 'sales_orders_replacement',
    'replacement_so_laptop_qc', 'so_laptop_qc', 'sales_order_cancel', 'delivery_challans', 'bluedart_awb_tracking', 'return_dc',
    'delivery_register_management', 'delivery_register_otp', 'technician_bucket', 'delivery_technicians', 'delivery_my_deliveries', 'technicians_bucket_list', 'payment_records',
  ],
  'Vendor & Procurement': ['vendor_management', 'procure_receiving', 'procure_amounts', 'procure_po_bills', 'po_approval', 'vendor_rentals', 'grn_pending_serial', 'vendor_repair_dc', 'vendor_repair_dc_dispatch', 'diagnosis_failed_decide', 'procurement', 'sales_pipeline'],
  'Master Data': ['inventory_master_data', 'inventory_vendor_master_data', 'inventory_return_master_data'],
  'Floor & Quality': ['floor_pipeline', 'floor_tickets', 'floor_ticket_config_edit', 'chip_level_repair', 'qc_management', 'dispatch_qc', 'dispatch_charger', 'dispatch_charger_reset', 'pending_inventory', 'diagnosis_failed', 'tickets', 'technician_performance', 'qc_performance', 'my_performance', 'picker_tasks', 'floor_roster'],
  Inventory: [
    'inventory', 'inventory_management', 'inventory_asset_movement', 'qc_add_laptop', 'qc_move_to_ticket', 'qc_create_production_ticket',
    'ready_to_rent_location',
    'customer_inventory', 'customer_assets', 'ttspl_history', 'asset_config_edit', 'stock_send_to_floor', 'stock_ready_send',
  ],
  'Part Management': [
    'parts_dashboard',
    'parts_inventory',
    'parts_approval',
    'part_request_cancel',
    'dispatch_charger_warehouse',
    'parts_approval_export',
    'parts_history',
    'parts_procurement',
    'part_vendor_repair',
    'parts_discarded',
    'physical_dead_parts',
    'scrap_challans',
    'scrap_approval',
    'parts_detach',
    'parts_requests',
    'support_part_challan',
    'support_part_requests',
    'parts',
  ],
  'Warehouse Gate': ['guard_gate_checking', 'gate_dashboard'],
  'Warehouse & Dispatch': ['warehouse', 'dispatch', 'dispatch_ops', 'dispatch_workflow', 'dispatch_pending_orders'],
  'Finance & Billing': [
    'customer_billing', 'vendor_billing_mgmt', 'credit_notes', 'debit_notes',
    'security_deposits', 'billing_dashboard', 'einvoice_ewb', 'dc_eway_bill', 'sale_in_place',
    'loan_laptop_approval',
  ],
  Support: ['support_tickets', 'support_closed_tickets', 'support_requests', 'support_settings', 'support_technician', 'loan_laptops', 'loan_laptop_policy'],
  Marketing: ['whatsapp_campaigns', 'whatsapp_campaigns_start', 'whatsapp_campaigns_pause', 'whatsapp_campaigns_cancel'],
  'Reports & Analytics': [
    'analytics_dashboard',
    'report_revenue',
    'report_inventory',
    'report_lead_conversion',
    'report_salesperson',
    'report_collections',
    'report_vendor_spend',
    'report_laptop',
    'report_warehouse_laptops',
    'report_sales_order',
    'report_support_daily',
    'report_inward_outward',
    'report_snapshot',
    'report_inward_outward_dashboard',
    'production_qc_report',
    'reports_export',
  ],
  'Settings & Admin': ['users', 'teams', 'roles', 'role_permissions', 'user_permissions', 'company_settings', 'asset_configuration'],
};

export const GROUP_COLORS = {
  Core: 'text-gray-600 border-gray-200',
  'Lead & Sales CRM': 'text-blue-600 border-blue-200',
  'Vendor & Procurement': 'text-emerald-600 border-emerald-200',
  'Master Data': 'text-purple-600 border-purple-200',
  'Floor & Quality': 'text-indigo-600 border-indigo-200',
  Inventory: 'text-teal-600 border-teal-200',
  'Part Management': 'text-orange-600 border-orange-200',
  'Warehouse Gate': 'text-teal-600 border-teal-200',
  'Warehouse & Dispatch': 'text-sky-600 border-sky-200',
  'Finance & Billing': 'text-amber-600 border-amber-200',
  Support: 'text-pink-600 border-pink-200',
  Marketing: 'text-green-600 border-green-200',
  'Reports & Analytics': 'text-violet-600 border-violet-200',
  'Settings & Admin': 'text-slate-600 border-slate-200',
};

export const PERMISSION_ACTIONS = ['can_view', 'can_create', 'can_edit', 'can_delete'];

/** Legacy umbrella keys — kept in DB for backward compat but hidden from role-permission UI. */
/** Empty: Master Vendor / Return Data can be granted to any role (Accounts, etc.). */
export const ADMIN_ONLY_RBAC_SECTIONS = [];

export const HIDDEN_ROLE_PERMISSION_SECTIONS = new Set([
  'sales_orders',
  'sales_orders_doc',
  'reports',
  'reports_access',
  'manager_dashboard',
]);

export function isHiddenRolePermissionSection(section) {
  return HIDDEN_ROLE_PERMISSION_SECTIONS.has(section);
}

export function visibleRolePermissionSections(sections) {
  return (sections || []).filter((s) => !isHiddenRolePermissionSection(s));
}

/** Merge API section keys with the frontend catalog so new modules always appear in RBAC UI. */
export function mergeRbacSectionList(apiSections) {
  const fromApi = (apiSections || [])
    .map((s) => (typeof s === 'string' ? s : s?.section))
    .filter(Boolean);
  return visibleRolePermissionSections([...new Set([...APPLICATION_SECTIONS, ...fromApi])]);
}

export const ACTION_ALIASES = {
  view: 'can_view',
  create: 'can_create',
  edit: 'can_edit',
  delete: 'can_delete',
};

export function normalizeAction(action) {
  if (!action) return null;
  const key = String(action).trim();
  if (PERMISSION_ACTIONS.includes(key)) return key;
  return ACTION_ALIASES[key] || null;
}
